module.exports = __webpack_public_path__ + "static/media/deviceIndicator.a45e2793.png";